  <div class="dashboard-wrapper d-flex">
    <main class="flex-grow-1 px-3">
      <!-- Header -->
      <header class="mb-4">
        <p class="fw-bold fst-italic fs-3 m-0 p-0">
          Welcome back,  {{ entity_name }}
        </p>
        <p class="text-dark text-xs mb-0">
          Here's an overview of your trust's status and compliance metrics.
        </p>

        <!-- Alert -->
        <div
          v-if="showAlert"
          class="alert alert-warning border-0 d-flex justify-content-between align-items-center mt-3 shadow-sm"
        >
          <div class="d-flex align-items-center gap-3">
            <i class="fas fa-exclamation-triangle fs-4 text-warning"></i>
            <div>
              <strong class="d-block text-xs">
                B-BBEE Verification Due Soon
              </strong>
              <span class="text-xs">
                Your annual B-BBEE verification is due in 45 days. Ensure all documentation is current.
              </span>
            </div>
          </div>
          <button class="btn-close" @click="showAlert = false"></button>
        </div>
      </header>

      <!-- Metrics -->
      <div class="row g-3 mb-4">
        <div
            v-for="metric in metrics"
            :key="metric.label"
            class="col-md-6 col-lg-3"
        >
            <div class="glassy-table border rounded-lg p-3 shadow-sm h-100">
            <div class="d-flex justify-content-between mb-3">
                <div
                class="rounded-3 d-inline-flex p-2"
                :class="metric.iconBg"
                >
                <i :class="metric.icon" class="fs-4"></i>
                </div>

                <small
                v-if="metric.trend"
                class="text-success fw-semibold text-xs"
                >
                <i class="fas fa-arrow-trend-up me-1"></i>
                {{ metric.trend }}
                </small>
            </div>

            <h4 class="fw-bold mb-1">{{ metric.value }}</h4>
            <p class="text-dark text-xs mb-1 fw-semibold">
                {{ metric.label }}
            </p>
            <small class="text-dark text-xxs">
                {{ metric.subtext }}
            </small>
            </div>
        </div>
      </div>

      <!-- Main Grid -->
      <div class="row g-4">

        <!-- Left Column -->
        <div class="col-lg-8">

          <!-- Recent Documents -->
          <div class="glassy-table border rounded-lg p-4 shadow-sm mb-4">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h6 class="fw-bold mb-1">Recent Documents</h6>
                <small class="text-muted">View-only building documents</small>
              </div>
              <a href="#" class="text-primary-blue small fw-bold text-decoration-none">
                View All
              </a>
            </div>

            <div class="list-group list-group-flush">
              <div
                v-for="doc in recentDocuments"
                :key="doc.name"
                class="list-group-item d-flex justify-content-between align-items-center px-3 p-2"
              >
                <div>
                  <p class="fw-bold small mb-1">{{ doc.name }}</p>
                  <small class="text-muted">
                    {{ doc.category }} • {{ doc.date }}
                  </small>
                </div>

                <button class="btn btn-link p-0 text-muted border-0">
                  <i class="far fa-eye"></i>
                </button>
              </div>
            </div>
          </div>

          <!-- Compliance Heatmap -->
          <div class="glassy-table border rounded-lg p-4 shadow-sm">
            <h6 class="fw-bold mb-3">Compliance Heatmap</h6>

            <div class="row g-3 text-center">
              <div
                v-for="item in heatmapData"
                :key="item.label"
                class="col-6 col-md-3 border rounded-lg"
              >
                <div
                  class="rounded-3 p-3 fw-bold"
                  :class="item.colorClass"
                >
                  {{ item.value }}%
                </div>
                <small class="text-muted d-block mt-2">
                  {{ item.label }}
                </small>
              </div>
            </div>
          </div>

        </div>

        <!-- Right Column -->
        <div class="col-lg-4">

          <!-- Compliance Score -->
          <div class="glassy-table border rounded-lg p-4 shadow-sm mb-4 text-center">
            <h6 class="fw-bold mb-3">Compliance Score</h6>

            <div class="display-5 fw-bold text-success mb-1">
              85%
            </div>
            <small class="text-success fw-semibold">
              Excellent
            </small>
          </div>

          <!-- Upcoming Meetings -->
          <div class="glassy-table border rounded-lg p-4 shadow-sm d-flex flex-column">
            <h6 class="fw-bold mb-3">Upcoming Meetings</h6>

            <div
              v-for="meeting in meetings"
              :key="meeting.id"
              class="mb-3"
            >
              <span
                class="badge small mb-1 bg-success text-white"
                :class="meeting.badgeClass"
              >
                {{ meeting.type }}
              </span>

              <p class="fw-bold small mb-1">
                {{ meeting.title }}
              </p>

              <small class="text-dark">
                {{ meeting.date }} • {{ meeting.time }}
              </small>
            </div>

            <button
              class="btn btn-primary-dark text-xs mt-auto w-100"
              @click="viewCalendar"
            >
              View Calendar
            </button>
          </div>

        </div>
      </div>
    </main>
  </div>